import React from 'react';
import { SearchBarStyled } from './search-bar.component.style';
import { TextFieldIconStyled, TextFieldWrapperStyled } from '@atomic/atm.text-field/text-field.component.style';
export const SearchBar = (props) => {
    return (React.createElement(TextFieldWrapperStyled, null,
        React.createElement(TextFieldIconStyled, null),
        React.createElement(SearchBarStyled, Object.assign({}, props))));
};
